const nlBlogKozijnSchilderen = {
  meta: {
    title: "Kozijn Schilderen of Vervangen ? | Advies & Kosten",
    description:
      "Twijfelt u tussen kozijn schilderen of vervangen ? Ontdek de kosten, voor- en nadelen en wanneer welke keuze het slimst is voor uw woning.",
  },
  hero: {
    h1: "Kozijn schilderen of vervangen ? De complete afweging",
    subtitle:
      "Houten kozijnen schilderen is goedkoper op korte termijn, maar vervangen levert structurele voordelen op. Wij helpen u de juiste keuze maken op basis van staat, kosten en energiebesparing.",
    image:
      "/img/02-freshly-painted-wooden-window.jpg",
    updated: "Laatst bijgewerkt mei 2026",
    readTime: "7 min leestijd",
  },
  toc: {
    title: "Inhoudsopgave",
    items: [
      "Kozijn schilderen : wanneer is het genoeg ?",
      "Kozijn vervangen : wanneer noodzakelijk ?",
      "Kosten vergelijken : schilderen vs vervangen",
      "De rol van energiebesparing en ISDE-subsidie",
      "Ons advies : eerlijke afweging",
      "Veelgestelde vragen",
    ],
  },
  sections: {
    schilderen: {
      h2: "Kozijn schilderen : wanneer is het genoeg ?",
      p1: "Schilderen is de meest voorkomende manier van onderhoud voor houten kozijnen. Wanneer het hout in goede staat is en er geen houtrot, barsten of structurele schade is, volstaat periodiek schilderen om de levensduur te verlengen. De juiste verflaag beschermt het hout tegen vocht, UV-straling en schimmels.",
      p2: "Ideaal voor schilderen zijn kozijnen die : cosmetisch verouderd zijn (afbladderende verf, verkleuring), licht beschadigd maar niet rot, recentelijk nog geschilderd zijn en waarvan het hout nog stevig aanvoelt. Met een goede voorbereiding — schuren, gronden, twee lagen verf — ziet een kozijn er weer jarenlang als nieuw uit.",
      costs: {
        intro: "De kosten van kozijn schilderen liggen tussen de volgende bedragen :",
        items: [
          { label: "Schilderen per kozijn (binnen + buiten)", price: "€ 150 – € 350" },
          { label: "Schilderen per vierkante meter", price: "€ 35 – € 65" },
          { label: "Volledige woning (gemiddeld)", price: "€ 1.200 – € 2.800" },
          { label: "Houtrot reparatie + schilderen", price: "€ 250 – € 450 per kozijn" },
        ],
        note: "Schilderen is goedkoper op korte termijn, maar dient elke 5 tot 7 jaar herhaald te worden.",
      },
    },
    vervangen: {
      h2: "Kozijn vervangen : wanneer noodzakelijk ?",
      p1: "Soms is schilderen niet meer voldoende. Kozijn vervangen is de enige optie wanneer het hout structureel beschadigd is door houtrot, barsten of vervorming. Ook wanneer het kozijn enkel glas bevat en u wilt overstappen op HR++ of triple glas, is vervanging meestal noodzakelijk.",
      p2: "Andere redenen om te vervangen : het kozijn is vervormd waardoor het raam niet meer sluit, er is lekkage of tocht die niet met reparatie op te lossen is, u wilt de esthetiek van de woning moderniseren, of u wilt energiebesparen met een beter isolerend kozijn met isolatieglas.",
      costs: {
        intro: "De kosten van kozijn vervangen variëren per materiaal en oppervlakte :",
        items: [
          { label: "Houten kozijn met HR++ glas", price: "€ 750 – € 1.100 per m²" },
          { label: "Kunststof kozijn met HR++ glas", price: "€ 650 – € 950 per m²" },
          { label: "Aluminium kozijn met isolatieglas", price: "€ 850 – € 1.300 per m²" },
          { label: "Kozijn vervangen + montage", price: "Inclusief in bovenstaande prijzen" },
        ],
        note: "Kozijn vervangen is duurder op korte termijn, maar bespaart op energiekosten en verhoogt de waarde van uw woning.",
      },
    },
    kostenVergelijking: {
      h2: "Kosten vergelijken : schilderen vs vervangen",
      p1: "Om de juiste keuze te maken, is het nuttig om de kosten op middellange termijn te vergelijken. Schilderen is goedkoper per keer, maar moet elke 5 tot 7 jaar herhaald worden. Kozijnvervanging is een eenmalige investering die 30 tot 50 jaar meegaat.",
      tableHead: ["Onderdeel", "Schilderen", "Repareren", "Vervangen"],
      tableRows: [
        ["Kosten per keer", "€ 150 – € 350 / kozijn", "€ 200 – € 500 / kozijn", "€ 650 – € 1.300 / m²"],
        ["Levensduur", "5 – 7 jaar tot volgend schilderwerk", "10 – 15 jaar (herstelde delen)", "30 – 50 jaar"],
        ["Energiebesparing", "Minimaal", "Middelmatig", "Maximaal (HR++ glas)"],
        ["Onderhoud", "Periodiek schilderen nodig", "Gedeeltelijk herstel + schilderen", "Nagenoeg onderhoudsvrij"],
        ["Aanpak houtrot", "Bij oppervlakkig : epoxy herstel", "Bij lokaal : reparatie mogelijk", "Bij structureel : vervanging nodig"],
      ],
      conclusion: "Voor een gemiddeld rijtjeshuis met 8 kozijnen is schilderen elke 7 jaar ongeveer € 2.000. In 30 jaar is dat € 8.000 aan schilderkosten. Vervanging kost eenmalig € 8.000 – € 12.000, maar levert direct energiebesparing op en verhoogt de waarde van de woning.",
    },
    energiebesparing: {
      h2: "De rol van energiebesparing en ISDE-subsidie",
      p1: "Wanneer u kiest voor kozijn vervangen met HR++ glas, realiseert u direct energiebesparing. Oude houten kozijnen met enkel glas verliezen enorm veel warmte. Modern HR++ glas reduceert dit warmteverlies met 50 tot 70 procent.",
      p2: "De ISDE-subsidie 2026 maakt kozijnvervanging financieel aantrekkelijker. Wanneer u nieuwe kozijnen laat plaatsen met energiezuinig glas, komt u in aanmerking voor subsidie tot duizenden euros. De subsidie wordt berekend op basis van de oppervlakte van het geplaatste glas.",
      p3: "Naast de ISDE-subsidie kunt u profiteren van lagere energiekosten. De investering in nieuwe kozijnen verdient zich in de loop van de jaren terug door de verlaagde stookkosten. In de meeste gevallen is de terugverdientijd 8 tot 15 jaar.",
      linkIsde: {
        text: "Lees meer over ISDE-subsidie 2026",
        href: "/blog/isde-subsidie-2026/",
      },
    },
    onsAdvies: {
      h2: "Ons advies : eerlijke afweging",
      p1: "Bij Ramen Repair Eindhoven adviseren wij altijd eerlijk. Wanneer schilderen volstaat, zeggen wij dat. Wanneer reparatie de betere keuze is, leggen wij uit waarom. En wanneer vervanging echt nodig is, zijn wij transparant over de kosten en voordelen.",
      p2: "Wij beoordelen het kozijn ter plaatse : inspecteren het hout op rot en barsten, controleren de sluiting en afdichting, beoordelen de staat van het glas, en geven een vrijblijvend advies met een prijsopgave. U beslist zelf.",
      links: [
        {
          text: "Kozijnreparatie in Eindhoven",
          href: "/kozijn-reparatie/",
        },
        {
          text: "Glas vervangen",
          href: "/glas-vervangen/",
        },
      ],
    },
  },
  faq: {
    h2: "Veelgestelde vragen over kozijn schilderen of vervangen",
    items: [
      {
        q: "Wat is goedkoper : kozijn schilderen of vervangen ?",
        a: "Op korte termijn is schilderen goedkoper (€ 150 – € 350 per kozijn). Op lange termijn (30 jaar) kan vervangen voordeliger zijn, omdat u periodiek schilderen elimineert en direct energie bespaart met HR++ glas.",
      },
      {
        q: "Hoe vaak moet ik houten kozijnen schilderen ?",
        a: "Houten kozijnen dienen elke 5 tot 7 jaar geschilderd te worden, afhankelijk van de kwaliteit van de verf en de blootstelling aan zon en regen. Zuidgevels schilderen vaker dan noordgevels.",
      },
      {
        q: "Wanneer is kozijn vervangen echt nodig ?",
        a: "Vervanging is nodig bij structurele houtrot, vervorming waardoor het raam niet sluit, lekkage die niet te repareren is, of wanneer u overstapt van enkel glas naar HR++ glas en het bestaande kozijn dit niet ondersteunt.",
      },
      {
        q: "Krijg ik subsidie bij kozijnvervanging ?",
        a: "Ja, via de ISDE-subsidie 2026 kunt u subsidie ontvangen wanneer u energiezuinig glas (HR++ of triple) plaatst in nieuwe kozijnen. De subsidie wordt berekend op de glasoppervlakte en kan oplopen tot duizenden euros.",
      },
    ],
  },
  cta: {
    text: "Twijfelt u tussen schilderen of vervangen ? Vraag gratis advies aan",
    phone: "040 798 7470",
  },
  schema: {
    headline: "Kozijn schilderen of vervangen ? De complete afweging",
    description:
      "Twijfelt u tussen kozijn schilderen of vervangen ? Ontdek de kosten, voor- en nadelen en wanneer welke keuze het slimst is voor uw woning.",
    author: "Ramen Repair Eindhoven",
    datePublished: "2026-05-28",
    dateModified: "2026-05-28",
  },
};

export default nlBlogKozijnSchilderen;